export const crossTable = {
	crossTableSettings: {
		editorQuestions: '.js-ct-editor-questions',
		editorAvailableQuestions: '.js-ct-editor-available-questions',
		editorAssignedQuestions: '.js-ct-editor-assigned-questions',
		editorQuestion: 'data-editor-question',
		editorQuestionSaveHandler: 'data-editor-question-save-handler',
	},
	crossTableQuestionsOverview: {
		questionsOverview: '.js-ct-questions-overview',
		questionsOverviewCollapsible: '.js-ct-questions-overview-collapsible',
		questionsOverviewCollapsibleItem: '.js-ct-questions-overview-collapsible-item',
		questionsOverviewCollapsibleItemRowAttribute: 'data-row-id',
		metadataEdit: '.js-ct-meta-icon',
		metadataItem: '.js-ct-meta-item',
		metadataCheckbox: '.js-ct-meta-checkbox',
		metadataValue: '.js-ct-meta-value',
		metadataTopBoxAnswers: '.js-ct-top-box-answers',
		metadataBottomBoxAnswers: '.js-ct-bottom-box-answers',
		metadataDetractors: '.js-ct-nps-detractors',
		metadataPromoters: '.js-ct-nps-promoters',
		labelAttribute: 'data-label',
		valueAttribute: 'data-value',
		typeAttribute: 'data-type',
		multipleAttribute: 'data-multiple',
		editValuesAttribute: 'data-values',
		editInfoElement: '.js-ct-qo-edit-info',
		handleAttribute: 'data-handle',
		calculations: {
			average: 'average',
			nps: 'nps',
			topBox: 'topbox',
			bottomBox: 'bottombox',
		},
	},
}
